import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Checkbox } from '@/components/ui/checkbox';
import { Loader2 } from 'lucide-react';

interface Activity {
  id: string;
  name: string;
}

interface ActivitySelectionCardProps {
  activities: Activity[];
  selectedActivities: string[];
  onActivityToggle: (id: string) => void;
  onImport: () => void;
  studentsCount: number;
  isImporting?: boolean;
}

export const ActivitySelectionCard = ({ 
  activities, 
  selectedActivities, 
  onActivityToggle, 
  onImport, 
  studentsCount,
  isImporting = false
}: ActivitySelectionCardProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Selecciona actividades para inscribir</CardTitle>
        <CardDescription>
          Los alumnos serán automáticamente inscritos en las actividades seleccionadas
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
          {activities.map((a) => (
            <div key={a.id} className="flex items-center space-x-2 p-3 rounded-lg border bg-card hover:bg-accent/50 transition-colors">
              <Checkbox
                id={a.id}
                checked={selectedActivities.includes(a.id)}
                onCheckedChange={() => onActivityToggle(a.id)}
              />
              <label
                htmlFor={a.id}
                className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 cursor-pointer flex-1"
              >
                {a.name}
              </label>
            </div>
          ))}
        </div>
        
        <div className="mt-6 flex justify-end">
          <Button 
            onClick={onImport} 
            disabled={selectedActivities.length === 0 || studentsCount === 0 || isImporting}
            className="w-full md:w-auto"
          >
            {isImporting ? (
              <>
                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                Importando...
              </>
            ) : (
              `Importar ${studentsCount} alumnos`
            )}
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};